module.exports = __webpack_public_path__ + "s/img/Chill_D_3.13b7c346.jpg";